/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
//import { renderErrorMsg } from '../../../assets/component/renderErrorMsg.js';
import { API_ENDPOINT, PLATFORM } from "../../../config";
import { simpleFetch } from "../../../restWrapper";

export function RenderOrgDocs(state, func, textObj) {
  if (!state || !func) return;

  if (!state.flies || state.flies.length < 1 || !state.flies === "empty") {
    fetchDoc();
  }
  function fetchDoc() {
    if (state.loading) return false;
    func.setState({
      loading: true,
    });
    simpleFetch("/organizations/files", "GET", {}).then((res) => {
      if (res.status === 200) {
        if (res.body.length >= 1) {
          func.setState({
            flies: res.body,
            loading: false,
          });
        } else {
          func.setState({
            flies: "empty",
            loading: false,
          });
        }
      } else {
        func.setState({
          flies: "",
          loading: false,
        });
      }
    });
  }

  function deleteDocBtn(id) {
    if (state.loading) return false;

    func.setState({
      loading: true,
    });
    simpleFetch("/organizations/files/" + id, "DELETE", {}).then((res) => {
      if (res.status === 204) {
        func.setState({
          deleteDocBtn: true,
        });
        fetchDoc();
      } else {
        func.setState({
          loading: false,
        });
      }
    });
  }

  function handleFile(e) {
    if (state.loading) return false;
    let data = new FormData();
    const file = e.target.files[0];
    if (file.type !== "application/pdf") return false;
    func.setState({
      loading: true,
    });
    data.append("file", file);
    if (data) {
      fetch(API_ENDPOINT + "/organizations/files", {
        // Your POST endpoint
        credentials: "include",
        method: "POST",
        body: data, // This is your file object
      }).then((res) => {
        fetchDoc();
      });
    }
  }

  function renderDocItems() {
    if (!state.flies || state.flies.length < 1 || state.flies === "empty")
      return;

    function renderItem(flie) {
      function downloadDoc() {
        if (state.loading) return false;
        func.setState({
          loading: true,
        });
        const link = !flie._id
          ? ""
          : API_ENDPOINT + "/organizations/files/" + flie._id;
        window.open(link, "_blank");

        func.setState({
          loading: false,
        });
      }

      function deleteBtn() {
        deleteDocBtn(flie._id);
      }

      const key = "flie" + flie._id;
      return (
        <div className="OrgDocs-item" key={key}>
          <div className="OrgDocs-docName" onClick={downloadDoc}>
            {flie.filename}
          </div>
          <div className="OrgDocs-deleteContainer" onClick={deleteBtn}>
            <div className="OrgDocs-deleteBtn"></div>
          </div>
        </div>
      );
    }

    return (
      <div className="OrgDocs-container">
        {state.flies.map((flie) => renderItem(flie))}
      </div>
    );
  }
  function renderLoadingIcon() {
    if (!state.loading) {
      return <div className="OrgDocs-addIcn"></div>;
    }
    return (
      <div className="OrgDocs-centerLoad">
        <div className="OrgDocs-loadIcn"></div>
      </div>
    );
  }

  return (
    <div className="OrgDocs-contentContainer">
      <div className="OrgDocs-contentHeader">
        <div className="OrgDocs-info">{textObj.info}</div>
        <div className="OrgDocs-addBtn">
          {renderLoadingIcon()}
          <input type="file" onChange={handleFile} />
        </div>
      </div>

      <div className="OrgDocs-content">
        <div className="OrgDocs-description">
          {PLATFORM === "plug" ? (
            // Business Text (Now Plug Text)
            <p>
              Please upload the latest Business Registration (BR) Document for
              Plug to verify that the organization is a registered business.
              <br />
              (PDF only)
            </p>
          ) : (
            // Nonprofit Text (Original)
            <>
              {textObj.description[0]}
              <br />
              {textObj.description[1]}
              <p />
              {textObj.description[2]}
            </>
          )}
        </div>
        {renderDocItems()}
      </div>

      <div className="OrgDocs-footer" />
    </div>
  );
}
